import React, { useState } from "react";
import "../style/footer.css";
import Footerlogo from "../assets/logo.png";
import { NavLink } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram } from "react-icons/fa";
import { MdLocationPin } from "react-icons/md";

const Footer = () => {
  const [menuActive, setMenuActive] = useState(false);

  return (
    <footer className="footer-container">
      <div className="container">
        <div className="footer-je">
          <div className="footer-content">

            {/* CENTER LOGO */}
            <div className="footer-section center-logo-section">
              <NavLink to="/" onClick={() => setMenuActive(false)}>
                <img src={Footerlogo} alt="Hospital Logo" className="footer-logo" />
              </NavLink>
            </div>

            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul className="footer-ul">
                <li><a href="/">Home</a></li>
                <li><a href="/about">About Us</a></li>
                <li><a href="/services">Services</a></li>
                <li><a href="/doctors">Doctors</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3>Services</h3>
              <ul className="footer-ul">
                <li><a href="/services/gastrology">Gastrology</a></li>
                <li><a href="/services/joint-replacement">Joint Replacement</a></li>
                <li><a href="/services/orthopedic">Orthopedics</a></li>
                <li><a href="/services/pediatric">Pediatric</a></li>
                <li><a href="/services/trauma-care">Trauma Care</a></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3>Contact Info</h3>

              <ul className="contact-info">

                {/* LOCATION */}
                <li className="contact-row">
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Laxmi+Multispeciality+Hospital+Shilaj+Ahmedabad"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon-link"
                  >
                    <MdLocationPin className="icon" />
                  </a>
                  <span>
                    3,4,5 GF & 101, 102 FF, Captown Enhance,<br />
                    Nr. Raj Thal, Sindhubhavan Ext. Road,<br />
                    Shilaj, Ahmedabad - 380059
                  </span>
                </li>

                {/* PHONE */}
                <li className="contact-row">
                  <a href="tel:+918480801010" className="icon-link">
                    <FaPhoneAlt className="icon" />
                  </a>
                  <span>+91-84 80 80 10 10</span>
                </li>

                {/* EMAIL */}
                <li className="contact-row">
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=laxmishilaj@gmail.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon-link"
                  >
                    <FaEnvelope className="icon" />
                  </a>
                  <span>laxmishilaj@gmail.com</span>
                </li>

              </ul>

              <div className="footer-social">
                <a
                  // href="https://www.facebook.com/yourpageusername"
                  href="https://www.facebook.com/p/Laxmi-Multispeciality-Hospital-Shilaj-61570410494662/"
                  target="_blank"
                  // rel="noopener noreferrer"
                  className="social-box"
                  // aria-label="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a
                  // href="https://www.instagram.com/laxmimultihospital_shilaj"
                  href="https://www.instagram.com/laxmimultihospital__shilaj/"
                  target="_blank"
                  // rel="noopener noreferrer"
                  className="social-box"
                  // aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            © 2025 Laxmi Multispeciality Hospital. All Rights Reserved.
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
